import * as React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../../components/Headers/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import classes from './DashboardLayout.module.css';

const DashboardLayout: React.FC = () => {
  const [expandSidebar, setExpandSidebar] = React.useState(false);
  return (
    <div className={classes.container}>
      <div className={classes.bodyContainer}>
        <Sidebar
          isExtended={expandSidebar}
          setIsExtended={() => setExpandSidebar(!expandSidebar)}
        />
        <div className={classes.pageContainer}>
          <Header
            loggedIn={true}
            expandedSidebar={expandSidebar}
            setShowSidebar={() => setExpandSidebar(!expandSidebar)}
          />
          <div className={classes.pageContent}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
